import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { InvoiceSummary, InvoiceDetail } from '../model/response/invoice-response';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = enviroment.BASE_URL_API + '/user/invoices';
  }

  getInvoices(): Observable<InvoiceSummary[]> {
    return this.http.get<any[]>(this.baseUrl).pipe(
      map(items => items.map(item => this.normalize(item)))
    );
  }

  getInvoiceDetail(id: string): Observable<InvoiceDetail> {
    return this.http.get<any>(`${this.baseUrl}/${id}`).pipe(
      map(item => this.normalize(item) as InvoiceDetail)
    );
  }

  /** XML da nota fiscal (só existe com nfStatus === 'issued'; 404 caso contrário). */
  downloadNfXml(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/nf-xml`, { responseType: 'blob' });
  }

  /**
   * Normaliza uma inconsistência da API: a listagem (GET /user/invoices) retorna
   * planID/tokenPackageID/stripeReceiptUrl, mas o detalhe (GET /user/invoices/{id})
   * retorna planId/tokenPackageId/receiptUrl para os mesmos dados. Aceita as duas
   * variantes de casing e sempre expõe o formato canônico pro resto do app.
   */
  private normalize(raw: any): InvoiceSummary {
    return {
      ...raw,
      planID: raw.planID ?? raw.planId ?? null,
      tokenPackageID: raw.tokenPackageID ?? raw.tokenPackageId ?? null,
      stripeReceiptUrl: raw.stripeReceiptUrl ?? raw.receiptUrl ?? null,
    };
  }
}
